// import { useState } from 'react';
import logo from '../../../assets/hav_bar__logo.png';
import './Footer.css';

const QUICK_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Contact Us', href: '#contact' },
];

// const SOCIALS = ['Twitter', 'Facebook', 'LinkedIn', 'Instagram'];

// function SocialIcon({ label }) {
//   const paths = {
//     Twitter: 'M22 5.9c-.7.3-1.5.5-2.3.6a4 4 0 0 0 1.7-2.2 8 8 0 0 1-2.5 1 4 4 0 0 0-6.9 3.6A11.4 11.4 0 0 1 3.6 4.6a4 4 0 0 0 1.2 5.3c-.6 0-1.2-.2-1.7-.5v.1a4 4 0 0 0 3.2 3.9c-.6.1-1.2.2-1.8.1a4 4 0 0 0 3.7 2.8A8 8 0 0 1 2 18.4a11.4 11.4 0 0 0 6.2 1.8c7.4 0 11.5-6.2 11.5-11.5v-.5c.8-.6 1.5-1.3 2-2.1Z',
//     Facebook: 'M13.5 21v-8h2.7l.4-3.2h-3V7.7c0-.9.3-1.6 1.6-1.6h1.5V3.2C15.9 3.1 15 3 14 3c-2.5 0-4.2 1.5-4.2 4.3v2.5H7v3.2h2.8v8h3.7Z',
//     LinkedIn: 'M6.9 8.6H3.6V21h3.3V8.6ZM5.3 3a1.9 1.9 0 1 0 0 3.9 1.9 1.9 0 0 0 0-3.9ZM21 21v-6.8c0-3.6-1.9-5.3-4.5-5.3-2.1 0-3 1.2-3.5 2v-1.7H9.7c0 .9 0 12.8 0 12.8H13v-7.2c0-.4 0-.8.1-1 .3-.8 1-1.6 2.2-1.6 1.6 0 2.2 1.2 2.2 3V21H21Z',
//     Instagram: 'M12 8.4a3.6 3.6 0 1 0 0 7.2 3.6 3.6 0 0 0 0-7.2ZM12 2c-2.7 0-3.1 0-4.1.1-1.1 .1-1.9.2-2.5.5a5 5 0 0 0-1.8 1.2A5 5 0 0 0 2.4 5.6c-.3.6-.5 1.4-.5 2.5C1.8 8.9 1.8 9.3 1.8 12s0 3.1.1 4.1c.1 1.1.2 1.9.5 2.5.3.7.6 1.2 1.2 1.8.5.6 1.1.9 1.8 1.2.6.3 1.4.5 2.5.5 1 .1 1.4.1 4.1.1s3.1 0 4.1-.1c1.1-.1 1.9-.2 2.5-.5.7-.3 1.2-.6 1.8-1.2.6-.5.9-1.1 1.2-1.8.3-.6.5-1.4.5-2.5.1-1 .1-1.4.1-4.1s0-3.1-.1-4.1c-.1-1.1-.2-1.9-.5-2.5a5 5 0 0 0-1.2-1.8A5 5 0 0 0 18.6 2.6c-.6-.3-1.4-.5-2.5-.5C15.1 2 14.7 2 12 2Z',
//   };

//   return (
//     <button type="button" className="footer__social" aria-label={label}>
//       <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
//         <path d={paths[label]} />
//       </svg>
//     </button>
//   );
// }

function Footer() {
  //   const [email, setEmail] = useState('');
  // const [submitted, setSubmitted] = useState(false);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (!email) return;
  //   setSubmitted(true);
  //   setEmail('');
  // };


  return (
    <footer className="footer" id="contact">
      <div className="container footer__grid">
        <div className="footer__brand">
          <div className="footer__logo-badge">
            <img src={logo} alt="Shrekruthi Phytoceuticals" />
          </div>
          <p className="footer__desc">
            We help pharmaceutical, nutraceutical and Ayurvedic companies stay
            ahead in a dynamic regulatory landscape by blending science,
            strategy and technology.
          </p>
          {/* <form className="footer__signup" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              aria-label="Email address"
              required
            />
            <button type="submit" className="btn btn-primary">
              Sign Up
            </button>
          </form>
          {submitted && <span className="footer__signup-msg">Thanks for subscribing!</span>} */}
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Get In Touch</h4>
          <ul className="footer__contact">
            <li>
              Plot No-28, Sri Durga Estates, Jeedimetla, Suchitra,
              Quthbullapur, Hyderabad &ndash; 500055
            </li>
            <li>
              <a href="mailto:info@shrekruthiphyto.com">info@shrekruthiphyto.com</a>
            </li>
            <li>
              <a href="tel:+919003069189">+91 90030 69189</a>
            </li>
          </ul>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Quick Links</h4>
          <ul className="footer__links">
            {QUICK_LINKS.map((link) => (
              <li key={link.href}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* <div className="footer__socials container">
        {SOCIALS.map((label) => (
          <SocialIcon key={label} label={label} />
        ))}
      </div> */}

      <div className="footer__bottom">
        <p>&copy; {new Date().getFullYear()} Shrekruthi Phytoceuticals. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
